module.exports = __webpack_public_path__ + "static/media/deleteCardIcon.b673b2f2.svg";